import { Button, Card, Checkbox, Flex, Image, Input } from "antd";
import React, { useEffect, useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import { BsCurrencyDollar } from "react-icons/bs";
import { updateValue } from "../../store/reducer/googleSearch";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
const { TextArea } = Input;

const ValuationItemCard = ({
   id,
   title,
   selectedItems,
   setSelectedItems,
   imageUrl,
   aiValue,
   allItems,
   dataIds,
}) => {
   const dispatch = useDispatch();
   const [value, setValue] = useState({
      itemId: id,
      googleValue: aiValue,
      itemName: title
   });

   const formatNumber = val => {
      // Remove all non-numeric characters except dot (.)
      val = val.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point
      const parts = val.split(".");
      if (parts.length > 2) {
         val = parts[0] + "." + parts.slice(1).join("");
      }

      // Convert to a number and format
      let number = parseFloat(val);

      if (isNaN(number)) return ""; // Handle empty input

      return number.toLocaleString("en-US", {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
   };

   const handleInputOnchange = e => {
      let val = e.target.value;
      val = val.replace(/[^0-9.]/g, "");
      setValue({
         ...value,
         googleValue: val,
      });
   };
   const handleInputNameOnchange = e => {
      let val = e.target.value;
      setValue({
         ...value,
         itemName: val,
      });
   };

   const handleDollarConversion = e => {
      let dollar = formatNumber(value.googleValue);
      setValue({
         ...value,
         googleValue: dollar,
      });
   };

   const handleCheckboxOnChange = e => {
      if (e.target.checked) {
         let findItem = allItems?.find(item => item.item_id == id);
         if (findItem) {
            // console.log([...selectedItems, findItem]);
            setSelectedItems([...selectedItems, findItem]);
         }
      } else {
         // let remove = selectedItems.filter(
         //    item => dataIds.includes(item.item_id) && item.item_id !== id
         // );
         let remove = selectedItems.filter(item => item.item_id !== id);
         console.log(remove);
         setSelectedItems(remove);
      }
   };

   const handleSubmit = e => {
      const postData = value;
      // console.log("value", postData);
      dispatch(updateValue({ postData }));
   };

   return (
      <Card
         type="inner"
         size="small"
         // title={title}
         style={{ maxHeight: 355 }}
         className="h-100"
         styles={{ header: { backgroundColor: "#e9ecef" } }}
         extra={
            <Checkbox
               key={id}
               checked={selectedItems?.some(item => item.item_id == id)}
               onChange={handleCheckboxOnChange}
            />
         }
      >
         <div className="w-100 text-center">
            <Image
               src={imageUrl}
               preview={false}
               //    height={150}
               style={{ height: 160 }}
            />
         </div>
         <Flex align="center" gap={10} className="mt-4">
            <label className="mb-1" style={{ whiteSpace: "nowrap" }}>
               Item Name
            </label>
            <TextArea
               autoSize
               size="small"
               value={value.itemName}
               onChange={handleInputNameOnchange}
               // readOnly={true}
               // onBlur={handleDollarConversion}
               placeholder="Item Name"
            />
         </Flex>
         <Flex align="center" gap={10} className="mt-2">
            <label className="mb-1" style={{ whiteSpace: "nowrap" }}>
               AI Estimate
            </label>
            <Input
               size="small"
               prefix={<BsCurrencyDollar />}
               value={value.googleValue}
               onChange={handleInputOnchange}
               // onBlur={handleDollarConversion}
               placeholder="AI Estimate"
            />
         </Flex>
         <div className="text-center">
            <Button
               size="small"
               shape="round"
               className="mt-2 text-white border-0"
               style={{ backgroundColor: "#F7931E" }}
               onClick={handleSubmit}
            >
               Submit
            </Button>
         </div>
      </Card>
   );
};

export default ValuationItemCard;
